import { Injectable } from '@angular/core';
import { Subject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
/**
 * Centralized tracking of platform level update triggers
 */
export class ViewUpdateService {
  /** Subject for triggering remote changes*/
  private _toUpdate = new Subject<any>();
  private _toUpdateList = new Subject<any>();
  /** Subject for monitoring route update changes*/
  routeState = new Subject<any>();

  constructor() {}

  /** Watch for remote changes*/
  registerChangePropagation(): Observable<any> {
    return this._toUpdate.asObservable();
  }
  /**
   * Trigger remote change
   * @param event Details of change
   */
  triggerChangePropagation(event) {
    // console.log(event);
    this._toUpdate.next(event);
  }
  /**
   * Trigger route update change event
   * @param ev Details about route change
   */
  routeUpdated(event) {
    this.routeState.next(event);
  }
  /** Watch for route update change event */
  monitorRouteChanges() {
    return this.routeState.asObservable();
  }
  /** Watch for changes in data item lists*/
  registerListUpdate() {
    return this._toUpdateList.asObservable();
  }

  /**
   * Trigger data item list change event
   * @param event Details of the change
   * {"list_type":'type of list', "parent_id":'data id of parent item', "type":'type of items in the list'}
   */
  triggerListChange(event) {
    this._toUpdateList.next(event);
  }
}
